import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { getStripedRowStyles } from "../../utils/tableRowStyle";
import { formatCurrency, formatPercentage } from "../../../../utils/functions";
import { CURRENCY_KEYS, PERCENTAGE_KEYS } from "./constants";

const HeaderRow = ({ columns }) => (
  <TableHead>
    <TableRow>
      {columns.map((col) => (
        <TableCell
          key={col.key}
          sx={{
            backgroundColor: "primary.white",
            fontWeight: "bold",
            // py: 2,
            border: 0,
            width: `${100 / columns.length}%`,
          }}
        >
          {col.label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

const DataRow = ({ row, columns, index }) => (
  <TableRow sx={getStripedRowStyles(index)}>
    {columns.map((col) => (
      <TableCell key={col.key}>
        {CURRENCY_KEYS.includes(col.key)
          ? formatCurrency(row[col.key])
          : PERCENTAGE_KEYS.includes(col.key)
            ? formatPercentage(row[col.key])
            : (row[col.key] ?? "-")}
      </TableCell>
    ))}
  </TableRow>
);

export const SpendTable = ({ columns, rows }) => {
  return (
    <Box>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: 0,
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <Table
          sx={{
            tableLayout: "fixed",
            borderSpacing: "0 6px",
            borderCollapse: "separate",
          }}
        >
          <HeaderRow columns={columns} />
          <TableBody>
            {rows.map((row, index) => (
              <DataRow
                key={row?.id ?? index}
                row={row}
                columns={columns}
                index={index}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
